import React, { useState } from "react";
import { Link } from "react-router-dom";

function Services() {
  const [activeService, setActiveService] = useState("General_Engineering");

  const services = [
    {
      id: "General_Engineering",
      title: "General Engineering",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
        >
          <path
            d="M22.2875 14.225C22.3375 13.825 22.375 13.425 22.375 13C22.375 12.575 22.3375 12.175 22.2875 11.775L24.925 9.71253C25.1625 9.52503 25.225 9.18753 25.075 8.91253L22.575 4.58753C22.5014 4.45856 22.3841 4.36006 22.2444 4.30966C22.1047 4.25927 21.9516 4.26029 21.8125 4.31253L18.7 5.56253C18.05 5.06253 17.35 4.65003 16.5875 4.33753L16.1125 1.02503C16.0914 0.878182 16.0176 0.744014 15.9049 0.647455C15.7923 0.550897 15.6484 0.498512 15.5 0.500032H10.5C10.1875 0.500032 9.92504 0.725032 9.88754 1.02503L9.41254 4.33753C8.65004 4.65003 7.95004 5.07503 7.30004 5.56253L4.18754 4.31253C4.11489 4.28863 4.03902 4.27599 3.96254 4.27503C3.75004 4.27503 3.53754 4.38753 3.42504 4.58753L0.925043 8.91253C0.762543 9.18753 0.837544 9.52503 1.07504 9.71253L3.71254 11.775C3.66254 12.175 3.62504 12.5875 3.62504 13C3.62504 13.4125 3.66254 13.825 3.71254 14.225L1.07504 16.2875C0.837544 16.475 0.775043 16.8125 0.925043 17.0875L3.42504 21.4125C3.49873 21.5415 3.61594 21.64 3.75567 21.6904C3.89539 21.7408 4.0485 21.7398 4.18754 21.6875L7.30004 20.4375C7.95004 20.9375 8.65004 21.35 9.41254 21.6625L9.88754 24.975C9.92504 25.275 10.1875 25.5 10.5 25.5H15.5C15.8125 25.5 16.075 25.275 16.1125 24.975L16.5875 21.6625C17.35 21.35 18.05 20.925 18.7 20.4375L21.8125 21.6875C21.8875 21.7125 21.9625 21.725 22.0375 21.725C22.25 21.725 22.4625 21.6125 22.575 21.4125L25.075 17.0875C25.225 16.8125 25.1625 16.475 24.925 16.2875L22.2875 14.225ZM19.8125 12.0875C19.8625 12.475 19.875 12.7375 19.875 13C19.875 13.2625 19.85 13.5375 19.8125 13.9125L19.6375 15.325L20.75 16.2L22.1 17.25L21.225 18.7625L19.6375 18.125L18.3375 17.6L17.2125 18.45C16.675 18.85 16.1625 19.15 15.65 19.3625L14.325 19.9L14.125 21.3125L13.875 23H12.125L11.8875 21.3125L11.6875 19.9L10.3625 19.3625C9.82504 19.1375 9.32504 18.85 8.82504 18.475L7.68754 17.6L6.36254 18.1375L4.77504 18.775L3.90004 17.2625L5.25004 16.2125L6.36254 15.3375L6.18754 13.925C6.15004 13.5375 6.12504 13.25 6.12504 13C6.12504 12.75 6.15004 12.4625 6.18754 12.0875L6.36254 10.675L5.25004 9.80003L3.90004 8.75003L4.77504 7.23753L6.36254 7.87503L7.66254 8.40003L8.78754 7.55003C9.32504 7.15003 9.83754 6.85003 10.35 6.63753L11.675 6.10003L11.875 4.68753L12.125 3.00003H13.8625L14.1 4.68753L14.3 6.10003L15.625 6.63753C16.1625 6.86253 16.6625 7.15003 17.1625 7.52503L18.3 8.40003L19.625 7.86253L21.2125 7.22503L22.0875 8.73753L20.75 9.80003L19.6375 10.675L19.8125 12.0875ZM13 8.00003C10.2375 8.00003 8.00004 10.2375 8.00004 13C8.00004 15.7625 10.2375 18 13 18C15.7625 18 18 15.7625 18 13C18 10.2375 15.7625 8.00003 13 8.00003ZM13 15.5C11.625 15.5 10.5 14.375 10.5 13C10.5 11.625 11.625 10.5 13 10.5C14.375 10.5 15.5 11.625 15.5 13C15.5 14.375 14.375 15.5 13 15.5Z"
            fill="#FFBF00"
          />
        </svg>
      ),
    },
    {
      id: "Vehicle_Development",
      title: "Vehicle Development",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M4.6875 14.6875C4.6875 14.0245 4.95089 13.3886 5.41973 12.9197C5.88857 12.4509 6.52446 12.1875 7.1875 12.1875H22.8125C23.4755 12.1875 24.1114 12.4509 24.5803 12.9197C25.0491 13.3886 25.3125 14.0245 25.3125 14.6875V22.1875H4.6875V14.6875Z"
            stroke="#FFBF00"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.75 17.5C9.44036 17.5 10 16.9404 10 16.25C10 15.5596 9.44036 15 8.75 15C8.05964 15 7.5 15.5596 7.5 16.25C7.5 16.9404 8.05964 17.5 8.75 17.5Z"
            fill="#FFBF00"
          />
          <path
            d="M21.25 17.5C21.9404 17.5 22.5 16.9404 22.5 16.25C22.5 15.5596 21.9404 15 21.25 15C20.5596 15 20 15.5596 20 16.25C20 16.9404 20.5596 17.5 21.25 17.5Z"
            fill="#FFBF00"
          />
          <path
            d="M12.5 18.4375H17.5M7.83875 6.95875C8.01405 6.47628 8.33363 6.05946 8.75407 5.76493C9.1745 5.4704 9.67541 5.31244 10.1888 5.3125H19.8112C20.3246 5.31244 20.8255 5.4704 21.2459 5.76493C21.6664 6.05946 21.9859 6.47628 22.1613 6.95875L24.0625 12.1875H5.9375L7.83875 6.95875ZM4.6875 22.1875H8.985V24.3125C8.985 24.7435 8.81379 25.1568 8.50905 25.4615C8.2043 25.7663 7.79098 25.9375 7.36 25.9375H6.3125C5.88152 25.9375 5.4682 25.7663 5.16345 25.4615C4.8587 25.1568 4.6875 24.7435 4.6875 24.3125V22.1875ZM21.0162 22.1875H25.3125V24.3125C25.3125 24.7435 25.1413 25.1568 24.8365 25.4615C24.5318 25.7663 24.1185 25.9375 23.6875 25.9375H22.6413C22.2103 25.9375 21.7969 25.7663 21.4922 25.4615C21.1875 25.1568 21.0162 24.7435 21.0162 24.3125V22.1875Z"
            stroke="#FFBF00"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: "3D_Services",
      title: "3D Services",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M15.0001 3.75L24.7426 9.375V19.1813C24.7426 19.6201 24.627 20.0512 24.4076 20.4312C24.1882 20.8112 23.8726 21.1268 23.4926 21.3462L16.2501 25.5288C15.87 25.7482 15.4389 25.8637 15.0001 25.8637C14.5612 25.8637 14.1301 25.7482 13.7501 25.5288L6.50757 21.3462C6.12753 21.1268 5.81194 20.8112 5.59252 20.4312C5.3731 20.0512 5.25758 19.6201 5.25757 19.1813V9.375L15.0001 3.75Z"
            stroke="#FFBF00"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.4125 10V16.25M15.4125 16.25L10 19.375M15.4125 16.25L20.825 19.375"
            stroke="#FFBF00"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="s-infrastructure" id="Services">
      <div className="s-infrastructure-heading">
        <h2>Our Services</h2>
        <p>
          From core mechanical engineering to advanced 3D technologies and
          full-scale vehicle development, our services span the complete product
          and vehicle lifecycle. Explore how Koios Engineering delivers
          specialized solutions across these domains—tailored, tested, and built
          for performance.
        </p>
      </div>
      <div className="s-services-container">
        <div className="s-services-container-heading">
          {services.map((service) => (
            <div
              key={service.id}
              className={`s-services-container-new-options `}
              onClick={() => setActiveService(service.id)}
            >
              <div
                className={`s-services-container-options ${
                  activeService === service.id ? "active-option" : ""
                }`}
              >
                <section>{service.icon}</section>
                <p>{service.title}</p>
              </div>

              {service.id === "General_Engineering" &&
                activeService === "General_Engineering" && (
                  <div className="s-services-container-info general-engineering">
                    <div className="s-services-container-info-left">
                      <section>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="49"
                          viewBox="0 0 48 49"
                          fill="none"
                        >
                          <mask id="path-1-inside-1_6459_8947" fill="white">
                            <path d="M38.8599 26.4601C38.9399 25.8201 38.9999 25.1801 38.9999 24.5001C38.9999 23.8201 38.9399 23.1801 38.8599 22.5401L43.0799 19.2401C43.4599 18.9401 43.5599 18.4001 43.3199 17.9601L39.3199 11.0401C39.202 10.8337 39.0145 10.6761 38.7909 10.5955C38.5674 10.5148 38.3224 10.5165 38.0999 10.6001L33.1199 12.6001C32.0799 11.8001 30.9599 11.1401 29.7399 10.6401L28.9799 5.34005C28.946 5.10509 28.828 4.89042 28.6477 4.73593C28.4675 4.58143 28.2373 4.49762 27.9999 4.50005H19.9999C19.4999 4.50005 19.0799 4.86005 19.0199 5.34005L18.2599 10.6401C17.0399 11.1401 15.9199 11.8201 14.8799 12.6001L9.89992 10.6001C9.78368 10.5618 9.66228 10.5416 9.53992 10.5401C9.19992 10.5401 8.85992 10.7201 8.67992 11.0401L4.67992 17.9601C4.41992 18.4001 4.53992 18.9401 4.91992 19.2401L9.13992 22.5401C9.05992 23.1801 8.99992 23.8401 8.99992 24.5001C8.99992 25.1601 9.05992 25.8201 9.13992 26.4601L4.91992 29.7601C4.53992 30.0601 4.43992 30.6001 4.67992 31.0401L8.67992 37.9601C8.79782 38.1664 8.98536 38.324 9.20892 38.4046C9.43248 38.4853 9.67745 38.4836 9.89992 38.4001L14.8799 36.4001C15.9199 37.2001 17.0399 37.8601 18.2599 38.3601L19.0199 43.6601C19.0799 44.1401 19.4999 44.5001 19.9999 44.5001H27.9999C28.4999 44.5001 28.9199 44.1401 28.9799 43.6601L29.7399 38.3601C30.9599 37.8601 32.0799 37.1801 33.1199 36.4001L38.0999 38.4001C38.2199 38.4401 38.3399 38.4601 38.4599 38.4601C38.7999 38.4601 39.1399 38.2801 39.3199 37.9601L43.3199 31.0401C43.5599 30.6001 43.4599 30.0601 43.0799 29.7601L38.8599 26.4601ZM34.8999 23.0401C34.9799 23.6601 34.9999 24.0801 34.9999 24.5001C34.9999 24.9201 34.9599 25.3601 34.8999 25.9601L34.6199 28.2201L36.3999 29.6201L38.5599 31.3001L37.1599 33.7201L34.6199 32.7001L32.5399 31.8601L30.7399 33.2201C29.8799 33.8601 29.0599 34.3401 28.2399 34.6801L26.1199 35.5401L25.7999 37.8001L25.3999 40.5001H22.5999L22.2199 37.8001L21.8999 35.5401L19.7799 34.6801C18.9199 34.3201 18.1199 33.8601 17.3199 33.26L15.4999 31.8601L13.3799 32.7201L10.8399 33.7401L9.43992 31.3201L11.5999 29.6401L13.3799 28.2401L13.0999 25.9801C13.0399 25.3601 12.9999 24.9001 12.9999 24.5001C12.9999 24.1001 13.0399 23.6401 13.0999 23.0401L13.3799 20.7801L11.5999 19.3801L9.43992 17.7001L10.8399 15.2801L13.3799 16.3001L15.4599 17.1401L17.2599 15.7801C18.1199 15.1401 18.9399 14.6601 19.7599 14.3201L21.8799 13.4601L22.1999 11.2001L22.5999 8.50005H25.3799L25.7599 11.2001L26.0799 13.4601L28.1999 14.3201C29.0599 14.6801 29.8599 15.1401 30.6599 15.7401L32.4799 17.1401L34.5999 16.2801L37.1399 15.2601L38.5399 17.6801L36.3999 19.3801L34.6199 20.7801L34.8999 23.0401ZM23.9999 16.5001C19.5799 16.5001 15.9999 20.0801 15.9999 24.5001C15.9999 28.9201 19.5799 32.5001 23.9999 32.5001C28.4199 32.5001 31.9999 28.9201 31.9999 24.5001C31.9999 20.0801 28.4199 16.5001 23.9999 16.5001ZM23.9999 28.5001C21.7999 28.5001 19.9999 26.7001 19.9999 24.5001C19.9999 22.3001 21.7999 20.5001 23.9999 20.5001C26.1999 20.5001 27.9999 22.3001 27.9999 24.5001C27.9999 26.7001 26.1999 28.5001 23.9999 28.5001Z" />
                          </mask>
                          <path
                            d="M38.8599 26.4601C38.9399 25.8201 38.9999 25.1801 38.9999 24.5001C38.9999 23.8201 38.9399 23.1801 38.8599 22.5401L43.0799 19.2401C43.4599 18.9401 43.5599 18.4001 43.3199 17.9601L39.3199 11.0401C39.202 10.8337 39.0145 10.6761 38.7909 10.5955C38.5674 10.5148 38.3224 10.5165 38.0999 10.6001L33.1199 12.6001C32.0799 11.8001 30.9599 11.1401 29.7399 10.6401L28.9799 5.34005C28.946 5.10509 28.828 4.89042 28.6477 4.73593C28.4675 4.58143 28.2373 4.49762 27.9999 4.50005H19.9999C19.4999 4.50005 19.0799 4.86005 19.0199 5.34005L18.2599 10.6401C17.0399 11.1401 15.9199 11.8201 14.8799 12.6001L9.89992 10.6001C9.78368 10.5618 9.66228 10.5416 9.53992 10.5401C9.19992 10.5401 8.85992 10.7201 8.67992 11.0401L4.67992 17.9601C4.41992 18.4001 4.53992 18.9401 4.91992 19.2401L9.13992 22.5401C9.05992 23.1801 8.99992 23.8401 8.99992 24.5001C8.99992 25.1601 9.05992 25.8201 9.13992 26.4601L4.91992 29.7601C4.53992 30.0601 4.43992 30.6001 4.67992 31.0401L8.67992 37.9601C8.79782 38.1664 8.98536 38.324 9.20892 38.4046C9.43248 38.4853 9.67745 38.4836 9.89992 38.4001L14.8799 36.4001C15.9199 37.2001 17.0399 37.8601 18.2599 38.3601L19.0199 43.6601C19.0799 44.1401 19.4999 44.5001 19.9999 44.5001H27.9999C28.4999 44.5001 28.9199 44.1401 28.9799 43.6601L29.7399 38.3601C30.9599 37.8601 32.0799 37.1801 33.1199 36.4001L38.0999 38.4001C38.2199 38.4401 38.3399 38.4601 38.4599 38.4601C38.7999 38.4601 39.1399 38.2801 39.3199 37.9601L43.3199 31.0401C43.5599 30.6001 43.4599 30.0601 43.0799 29.7601L38.8599 26.4601ZM34.8999 23.0401C34.9799 23.6601 34.9999 24.0801 34.9999 24.5001C34.9999 24.9201 34.9599 25.3601 34.8999 25.9601L34.6199 28.2201L36.3999 29.6201L38.5599 31.3001L37.1599 33.7201L34.6199 32.7001L32.5399 31.8601L30.7399 33.2201C29.8799 33.8601 29.0599 34.3401 28.2399 34.6801L26.1199 35.5401L25.7999 37.8001L25.3999 40.5001H22.5999L22.2199 37.8001L21.8999 35.5401L19.7799 34.6801C18.9199 34.3201 18.1199 33.8601 17.3199 33.26L15.4999 31.8601L13.3799 32.7201L10.8399 33.7401L9.43992 31.3201L11.5999 29.6401L13.3799 28.2401L13.0999 25.9801C13.0399 25.3601 12.9999 24.9001 12.9999 24.5001C12.9999 24.1001 13.0399 23.6401 13.0999 23.0401L13.3799 20.7801L11.5999 19.3801L9.43992 17.7001L10.8399 15.2801L13.3799 16.3001L15.4599 17.1401L17.2599 15.7801C18.1199 15.1401 18.9399 14.6601 19.7599 14.3201L21.8799 13.4601L22.1999 11.2001L22.5999 8.50005H25.3799L25.7599 11.2001L26.0799 13.4601L28.1999 14.3201C29.0599 14.6801 29.8599 15.1401 30.6599 15.7401L32.4799 17.1401L34.5999 16.2801L37.1399 15.2601L38.5399 17.6801L36.3999 19.3801L34.6199 20.7801L34.8999 23.0401ZM23.9999 16.5001C19.5799 16.5001 15.9999 20.0801 15.9999 24.5001C15.9999 28.9201 19.5799 32.5001 23.9999 32.5001C28.4199 32.5001 31.9999 28.9201 31.9999 24.5001C31.9999 20.0801 28.4199 16.5001 23.9999 16.5001ZM23.9999 28.5001C21.7999 28.5001 19.9999 26.7001 19.9999 24.5001C19.9999 22.3001 21.7999 20.5001 23.9999 20.5001C26.1999 20.5001 27.9999 22.3001 27.9999 24.5001C27.9999 26.7001 26.1999 28.5001 23.9999 28.5001Z"
                            fill="#FFBF00"
                            stroke="#2B2B2B"
                            strokeWidth="2.4"
                            mask="url(#path-1-inside-1_6459_8947)"
                          />
                        </svg>
                      </section>
                      <h3>General Engineering</h3>
                      <p>
                        At Koios Engineering, our General Engineering services
                        are built on precision, innovation, and performance. We
                        bring together advanced mechanical design, detailed CAD
                        modeling, and expert manufacturing to deliver
                        engineering solutions that meet real-world demands.
                        Whether it’s a single component or a complex system, we
                        design and build with purpose.
                      </p>
                      <Link
                        to="/general-engineering-services"
                        className="yellow-button"
                      >
                        <p>Explore</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="7"
                          height="13"
                          viewBox="0 0 7 13"
                          fill="none"
                        >
                          <path
                            d="M2.00933 12.089L0.833496 10.9106L5.24099 6.49981L0.833496 2.08898L2.01266 0.910645L6.41682 5.32148C6.72927 5.63402 6.9048 6.05787 6.9048 6.49981C6.9048 6.94175 6.72927 7.3656 6.41682 7.67814L2.00933 12.089Z"
                            fill="#1A1A1A"
                          />
                        </svg>
                      </Link>
                    </div>
                    <div className="s-services-container-info-line"></div>
                    <div className="s-services-container-info-right">
                      <Link
                        to="/mechanical_design"
                        className="s-services-container-info-set"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M3.29594 21.1018L9.65994 14.7378M17.6739 11.9078L15.7689 17.6228C15.7385 17.7144 15.6865 17.7974 15.6172 17.8646C15.5479 17.9318 15.4634 17.9813 15.3709 18.0088L3.69294 21.4798C3.58773 21.5111 3.47597 21.5129 3.36981 21.485C3.26365 21.4572 3.16717 21.4007 3.09087 21.3218C3.01456 21.2429 2.96135 21.1446 2.93703 21.0376C2.91272 20.9306 2.91822 20.819 2.95294 20.7148L6.74494 9.34084C6.77212 9.25917 6.81655 9.18431 6.87521 9.12133C6.93388 9.05835 7.0054 9.00873 7.08494 8.97584L12.4719 6.75784C12.5815 6.71261 12.7019 6.70082 12.8181 6.72395C12.9343 6.74709 13.0411 6.80411 13.1249 6.88784L17.5289 11.2938C17.6077 11.3726 17.663 11.4718 17.6887 11.5802C17.7143 11.6887 17.7092 11.8021 17.6739 11.9078Z"
                            stroke="url(#paint0_linear_6466_8960)"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M17.7918 11.556L20.6198 8.72699C20.9948 8.35194 21.2054 7.84332 21.2054 7.31299C21.2054 6.78266 20.9948 6.27405 20.6198 5.89899L18.4998 3.77699C18.3141 3.59119 18.0936 3.4438 17.8509 3.34324C17.6082 3.24268 17.3481 3.19092 17.0853 3.19092C16.8226 3.19092 16.5625 3.24268 16.3198 3.34324C16.0771 3.4438 15.8566 3.59119 15.6708 3.77699L12.8428 6.60599M11.7808 12.616C11.6415 12.4767 11.4761 12.3663 11.2941 12.2909C11.1121 12.2156 10.917 12.1768 10.72 12.1769C10.523 12.1769 10.3279 12.2158 10.1459 12.2912C9.96396 12.3666 9.79861 12.4772 9.65934 12.6165C9.52007 12.7558 9.40962 12.9212 9.33427 13.1032C9.25892 13.2853 9.22017 13.4803 9.22021 13.6773C9.22026 13.8743 9.25911 14.0694 9.33454 14.2514C9.40997 14.4334 9.52051 14.5987 9.65984 14.738C9.94124 15.0193 10.3228 15.1772 10.7207 15.1771C11.1186 15.177 11.5001 15.0189 11.7813 14.7375C12.0626 14.4561 12.2206 14.0745 12.2205 13.6766C12.2204 13.2788 12.0622 12.8973 11.7808 12.616Z"
                            stroke="url(#paint1_linear_6466_8960)"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_6466_8960"
                              x1="10.3134"
                              y1="6.7124"
                              x2="10.3134"
                              y2="21.5047"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_6466_8960"
                              x1="15.2128"
                              y1="3.19092"
                              x2="15.2128"
                              y2="15.1771"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>Design</h4>
                      </Link>
                      <Link
                        to="/mechanical_manufacturing"
                        className="s-services-container-info-set"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M20.4692 6.33333L15 11.7375V6.33333H13.5615L8.33333 11.6361V3H2V23H22V6.33333H20.4692ZM20.6667 21.6667H3.33333V4.33333H7V13.3333H8.53242L13.6667 8.12575V13.3333H15.2818L20.6667 8.0125V21.6667Z"
                            fill="url(#paint0_linear_6473_9196)"
                            fillOpacity="0.8"
                          />
                          <path
                            d="M5 16.1635V16.5096H6.76471V15.125H5V16.1635ZM5 18.2404H6.76471V19.625H5V18.2404ZM9.41176 16.1635V16.5096H11.1765V15.125H9.41176V16.1635ZM9.41176 18.2404H11.1765V19.625H9.41176V18.2404ZM13.8235 16.1635V16.5096H15.5882V15.125H13.8235V16.1635ZM13.8235 18.2404H15.5882V19.625H13.8235V18.2404ZM18.2353 15.125H20V16.5096H18.2353V15.125ZM18.2353 18.2404H20V19.625H18.2353V18.2404Z"
                            fill="url(#paint1_linear_6473_9196)"
                            fillOpacity="0.8"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_6473_9196"
                              x1="12"
                              y1="3"
                              x2="12"
                              y2="23"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_6473_9196"
                              x1="12.5"
                              y1="15.125"
                              x2="12.5"
                              y2="19.625"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>Manufacturing</h4>
                      </Link>
                    </div>
                  </div>
                )}

              {service.id === "Vehicle_Development" &&
                activeService === "Vehicle_Development" && (
                  <div className="s-services-container-info vehicle-development">
                    <div className="s-services-container-info-left">
                      <section>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="49"
                          viewBox="0 0 48 49"
                          fill="none"
                        >
                          <path
                            d="M7.5 24C7.5 22.9391 7.92143 21.9217 8.67157 21.1716C9.42172 20.4214 10.4391 20 11.5 20H36.5C37.5609 20 38.5783 20.4214 39.3284 21.1716C40.0786 21.9217 40.5 22.9391 40.5 24V36H7.5V24Z"
                            stroke="#FFBF00"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M14 28.5C15.1046 28.5 16 27.6046 16 26.5C16 25.3954 15.1046 24.5 14 24.5C12.8954 24.5 12 25.3954 12 26.5C12 27.6046 12.8954 28.5 14 28.5Z"
                            fill="#FFBF00"
                          />
                          <path
                            d="M34 28.5C35.1046 28.5 36 27.6046 36 26.5C36 25.3954 35.1046 24.5 34 24.5C32.8954 24.5 32 25.3954 32 26.5C32 27.6046 32.8954 28.5 34 28.5Z"
                            fill="#FFBF00"
                          />
                          <path
                            d="M20 30H28M12.542 11.634C12.8225 10.862 13.3338 10.1951 14.0065 9.72389C14.6792 9.25265 15.4807 8.9999 16.302 9H31.698C32.5193 8.9999 33.3208 9.25265 33.9935 9.72389C34.6662 10.1951 35.1775 10.862 35.458 11.634L38.5 20H9.5L12.542 11.634ZM7.5 36H14.376V39.4C14.376 40.0896 14.1021 40.7509 13.6145 41.2385C13.1269 41.7261 12.4656 42 11.776 42H10.1C9.41044 42 8.74912 41.7261 8.26152 41.2385C7.77393 40.7509 7.5 40.0896 7.5 39.4V36ZM33.626 36H40.5V39.4C40.5 40.0896 40.2261 40.7509 39.7385 41.2385C39.2509 41.7261 38.5896 42 37.9 42H36.226C35.5364 42 34.8751 41.7261 34.3875 41.2385C33.8999 40.7509 33.626 40.0896 33.626 39.4V36Z"
                            stroke="#FFBF00"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </section>
                      <h3>Vehicle Development</h3>
                      <p>
                        We Build vehicles from the stage of design to
                        manufacturing prototype which involves multiple
                        activities which contribute to deliver a vehicle which
                        is tested extensively to meet the technical requirement
                        to ply on the roads safely .
                      </p>
                      <Link to="/vehicle-development" className="yellow-button">
                        <p>Explore</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="7"
                          height="13"
                          viewBox="0 0 7 13"
                          fill="none"
                        >
                          <path
                            d="M2.00933 12.089L0.833496 10.9106L5.24099 6.49981L0.833496 2.08898L2.01266 0.910645L6.41682 5.32148C6.72927 5.63402 6.9048 6.05787 6.9048 6.49981C6.9048 6.94175 6.72927 7.3656 6.41682 7.67814L2.00933 12.089Z"
                            fill="#1A1A1A"
                          />
                        </svg>
                      </Link>
                    </div>
                    <div className="s-services-container-info-line"></div>
                    <div className="s-services-container-info-right">
                      {/* <a href="#" className="s-services-container-info-set">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M7.5 10.325H11.5V11.375H7.5V10.325ZM7.5 8.225H13.5V9.275H7.5V8.225ZM7.5 6.125H13.5V7.175H7.5V6.125Z"
                            fill="url(#paint0_linear_113_1694)"
                            fillOpacity="0.8"
                          />
                          <path
                            d="M3.93643 21.5714L7.95857 14.4314L13.2686 19.0671C13.4291 19.21 13.6198 19.3148 13.8264 19.3737C14.033 19.4326 14.2503 19.4442 14.462 19.4075C14.6737 19.3709 14.8744 19.2869 15.0492 19.162C15.2239 19.037 15.3683 18.8742 15.4714 18.6857L20.45 11.255L19.2636 10.4593L14.2636 17.9221L14.2136 17.9957L8.90286 13.36C8.74239 13.218 8.55208 13.1138 8.34596 13.0552C8.13985 12.9966 7.9232 12.985 7.71202 13.0214C7.50083 13.0577 7.30051 13.141 7.12584 13.2652C6.95118 13.3893 6.80662 13.5511 6.70286 13.7386L3.42857 19.5593V3H2V21.5714C2 21.9503 2.15051 22.3137 2.41842 22.5816C2.68633 22.8495 3.04969 23 3.42857 23H22V21.5714H3.93643Z"
                            fill="url(#paint1_linear_113_1694)"
                            fillOpacity="0.8"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_113_1694"
                              x1="10.5"
                              y1="6.125"
                              x2="10.5"
                              y2="11.375"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_113_1694"
                              x1="12"
                              y1="3"
                              x2="12"
                              y2="23"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>Fea</h4>
                      </a>
                      <a href="#" className="s-services-container-info-set">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M17.25 4C18.2446 4 19.1984 4.39509 19.9016 5.09835C20.6049 5.80161 21 6.75544 21 7.75V9.25C21 9.44891 20.921 9.63968 20.7803 9.78033C20.6397 9.92098 20.4489 10 20.25 10C20.0511 10 19.8603 9.92098 19.7197 9.78033C19.579 9.63968 19.5 9.44891 19.5 9.25V7.75C19.5 7.15326 19.2629 6.58097 18.841 6.15901C18.419 5.73705 17.8467 5.5 17.25 5.5H15.75C15.5511 5.5 15.3603 5.42098 15.2197 5.28033C15.079 5.13968 15 4.94891 15 4.75C15 4.55109 15.079 4.36032 15.2197 4.21967C15.3603 4.07902 15.5511 4 15.75 4H17.25ZM6.75 4C5.75544 4 4.80161 4.39509 4.09835 5.09835C3.39509 5.80161 3 6.75544 3 7.75V9.25C3 9.44891 3.07902 9.63968 3.21967 9.78033C3.36032 9.92098 3.55109 10 3.75 10C3.94891 10 4.13968 9.92098 4.28033 9.78033C4.42098 9.63968 4.5 9.44891 4.5 9.25V7.75C4.5 7.15326 4.73705 6.58097 5.15901 6.15901C5.58097 5.73705 6.15326 5.5 6.75 5.5H8.25C8.44891 5.5 8.63968 5.42098 8.78033 5.28033C8.92098 5.13968 9 4.94891 9 4.75C9 4.55109 8.92098 4.36032 8.78033 4.21967C8.63968 4.07902 8.44891 4 8.25 4H6.75ZM17.25 22C18.2446 22 19.1984 21.6049 19.9016 20.9016C20.6049 20.1984 21 19.2446 21 18.25V16.75C21 16.5511 20.921 16.3603 20.7803 16.2197C20.6397 16.079 20.4489 16 20.25 16C20.0511 16 19.8603 16.079 19.7197 16.2197C19.579 16.3603 19.5 16.5511 19.5 16.75V18.25C19.5 18.8467 19.2629 19.419 18.841 19.841C18.419 20.2629 17.8467 20.5 17.25 20.5H15.75C15.5511 20.5 15.3603 20.579 15.2197 20.7197C15.079 20.8603 15 21.0511 15 21.25C15 21.4489 15.079 21.6397 15.2197 21.7803C15.3603 21.921 15.5511 22 15.75 22H17.25ZM3 18.25C3 19.2446 3.39509 20.1984 4.09835 20.9016C4.80161 21.6049 5.75544 22 6.75 22H8.25C8.44891 22 8.63968 21.921 8.78033 21.7803C8.92098 21.6397 9 21.4489 9 21.25C9 21.0511 8.92098 20.8603 8.78033 20.7197C8.63968 20.579 8.44891 20.5 8.25 20.5H6.75C6.15326 20.5 5.58097 20.2629 5.15901 19.841C4.73705 19.419 4.5 18.8467 4.5 18.25V16.75C4.5 16.5511 4.42098 16.3603 4.28033 16.2197C4.13968 16.079 3.94891 16 3.75 16C3.55109 16 3.36032 16.079 3.21967 16.2197C3.07902 16.3603 3 16.5511 3 16.75V18.25ZM12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13C15 12.2044 14.6839 11.4413 14.1213 10.8787C13.5587 10.3161 12.7956 10 12 10C11.2044 10 10.4413 10.3161 9.87868 10.8787C9.31607 11.4413 9 12.2044 9 13C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16ZM12 14.5C11.6022 14.5 11.2206 14.342 10.9393 14.0607C10.658 13.7794 10.5 13.3978 10.5 13C10.5 12.6022 10.658 12.2206 10.9393 11.9393C11.2206 11.658 11.6022 11.5 12 11.5C12.3978 11.5 12.7794 11.658 13.0607 11.9393C13.342 12.2206 13.5 12.6022 13.5 13C13.5 13.3978 13.342 13.7794 13.0607 14.0607C12.7794 14.342 12.3978 14.5 12 14.5ZM7.5 9.625C7.79837 9.625 8.08452 9.50647 8.2955 9.2955C8.50647 9.08452 8.625 8.79837 8.625 8.5C8.625 8.20163 8.50647 7.91548 8.2955 7.7045C8.08452 7.49353 7.79837 7.375 7.5 7.375C7.20163 7.375 6.91548 7.49353 6.7045 7.7045C6.49353 7.91548 6.375 8.20163 6.375 8.5C6.375 8.79837 6.49353 9.08452 6.7045 9.2955C6.91548 9.50647 7.20163 9.625 7.5 9.625Z"
                            fill="url(#paint0_linear_113_1699)"
                            fillOpacity="0.8"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_113_1699"
                              x1="12"
                              y1="4"
                              x2="12"
                              y2="22"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>Styling</h4>
                      </a> */}
                      <Link
                        to="/automotive-manufacturing-solutions"
                        className="s-services-container-info-set"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M18.2661 5.81061L18.1585 5H15.6436L15.5358 5.81009L15.4686 6.31198L15.3366 6.38834L15.2183 6.46634L14.7734 6.27702L14.0565 5.97209L13.6695 6.67873L13.1883 7.55722L12.8006 8.26508L13.41 8.76945L13.7865 9.08094L13.7853 9.09552C13.7831 9.14206 13.782 9.18865 13.782 9.23525L13.7853 9.37386L13.7874 9.39341L13.4101 9.70602L12.8003 10.2103L13.1881 10.9184L13.6696 11.7973L14.0565 12.5039L14.7734 12.1991L15.2174 12.0099L15.3408 12.0914L15.4686 12.1642L15.5346 12.66L15.6421 13.4705H18.1569L18.2648 12.6605L18.3312 12.1576L18.464 12.0822L18.5815 12.0033L19.0271 12.1935L19.744 12.4984L20.1311 11.7918L20.6122 10.9133L21 10.2055L20.3906 9.70109L20.0142 9.38961L20.0152 9.37503C20.0174 9.32784 20.0186 9.28125 20.0185 9.23525L20.0153 9.09669L20.0133 9.07527L20.3907 8.76402L21 8.25964L20.6122 7.55183L20.131 6.67316L19.7439 5.96666L19.0272 6.27144L18.5824 6.45973L18.4598 6.37906L18.3312 6.30537L18.2661 5.81061ZM16.9877 11.1176C17.9719 11.1176 18.7696 10.2748 18.7696 9.23525C18.7696 8.19566 17.9719 7.35294 16.9877 7.35294C16.0036 7.35294 15.2059 8.19566 15.2059 9.23525C15.2059 10.2748 16.0036 11.1176 16.9877 11.1176ZM8.46567 13.34L8.35819 12.5294H5.84325L5.73539 13.3394L5.66822 13.8414L5.53622 13.9177L5.41786 13.9957L4.97306 13.8065L4.2562 13.5015L3.86916 14.2082L3.38794 15.0867L3.00019 15.7945L3.60956 16.2989L3.98611 16.6103L3.98503 16.6249C3.98279 16.6715 3.98165 16.7181 3.98161 16.7647L3.98494 16.9032L3.98705 16.9228L3.6097 17.2355L3 17.7397L3.3878 18.4478L3.8692 19.3267L4.2562 20.0333L4.97302 19.7285L5.41697 19.5393L5.54044 19.6209L5.66822 19.6936L5.73431 20.1894L5.84184 21H8.35659L8.46445 20.1899L8.53083 19.687L8.66363 19.6116L8.78119 19.5327L9.22678 19.7229L9.94364 20.0278L10.3307 19.3212L10.8119 18.4427L11.1997 17.7349L10.5902 17.2305L10.2138 16.919L10.2148 16.9045C10.2171 16.8572 10.2182 16.8106 10.2182 16.7647L10.2149 16.6261L10.2129 16.6047L10.5903 16.2935L11.1997 15.7891L10.8119 15.0813L10.3306 14.2026L9.94364 13.496L9.22683 13.8008L8.78208 13.9892L8.65941 13.9085L8.53083 13.8348L8.46567 13.34ZM7.18739 18.647C8.17148 18.647 8.96925 17.8043 8.96925 16.7647C8.96925 15.725 8.17148 14.8823 7.18739 14.8823C6.20325 14.8823 5.40548 15.725 5.40548 16.7647C5.40548 17.8043 6.20325 18.647 7.18739 18.647ZM21 19H12V21H21V19ZM3 5H12V6.99997H3V5ZM12 11H9.99998V13H12V11Z"
                            fill="url(#paint0_linear_113_1704)"
                            fillOpacity="0.8"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_113_1704"
                              x1="12"
                              y1="5"
                              x2="12"
                              y2="21"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>Automotive Manufacturing</h4>
                      </Link>
                      <Link
                        to="/automotive-design-services"
                        className="s-services-container-info-set"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M23 10H21.5C20.9473 10 20.4688 10.3038 20.2085 10.75H5.051L7.01975 5.5H12.5V4H7.01975C6.71467 4.00096 6.41706 4.09445 6.16625 4.26813C5.91543 4.44182 5.72322 4.68751 5.615 4.97275L3.7295 10H2V11.5H3.5V18.25C3.5 19.0765 4.17275 19.75 5 19.75V22H6.5V19.75H18.5V22H20V19.75C20.8265 19.75 21.5 19.0765 21.5 18.25V11.5H23V10ZM5 18.25V16H7.25V14.5H5V12.25H20V14.5H17.75V16H20V18.25H5Z"
                            fill="url(#paint0_linear_113_1709)"
                            fillOpacity="0.8"
                          />
                          <path
                            d="M8.98413 15.4558H14.9841V16.9558H8.98413V15.4558ZM22.1526 2.39453L17.2101 7.33703L15.2676 5.39453L14.2101 6.45203L17.2101 9.45203L23.2101 3.45203L22.1526 2.39453Z"
                            fill="url(#paint1_linear_113_1709)"
                            fillOpacity="0.8"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_113_1709"
                              x1="12.5"
                              y1="4"
                              x2="12.5"
                              y2="22"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_113_1709"
                              x1="16.0971"
                              y1="2.39453"
                              x2="16.0971"
                              y2="16.9558"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>Automotive Design</h4>
                      </Link>
                      <Link
                        to="/electric-vehicle-development-services"
                        className="s-services-container-info-set"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M10 13.154V21M13.333 6.385V3M6.667 6.385V3M15 8.385V11.154C15 11.6844 14.7893 12.1931 14.4142 12.5682C14.0391 12.9433 13.5304 13.154 13 13.154H7C6.46957 13.154 5.96086 12.9433 5.58579 12.5682C5.21071 12.1931 5 11.6844 5 11.154L5 8.384C5 7.85357 5.21071 7.34486 5.58579 6.96979C5.96086 6.59471 6.46957 6.384 7 6.384H13C13.5304 6.384 14.0391 6.59471 14.4142 6.96979C14.7893 7.34486 15 7.85357 15 8.384V8.385Z"
                            stroke="url(#paint0_linear_113_1689)"
                            strokeOpacity="0.8"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            d="M16.667 16L15 19H19L17.333 22"
                            stroke="url(#paint1_linear_113_1689)"
                            strokeOpacity="0.8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_113_1689"
                              x1="10"
                              y1="3"
                              x2="10"
                              y2="21"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_113_1689"
                              x1="17"
                              y1="16"
                              x2="17"
                              y2="22"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>Electric Vehicle</h4>
                      </Link>
                    </div>
                  </div>
                )}

              {service.id === "3D_Services" &&
                activeService === "3D_Services" && (
                  <div className="s-services-container-info threeD-services">
                    <div className="s-services-container-info-left">
                      <section>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="49"
                          viewBox="0 0 48 49"
                          fill="none"
                        >
                          <path
                            d="M24.0001 6.5L39.5881 15.5V31.19C39.5881 31.8921 39.4033 32.5819 39.0522 33.1899C38.7011 33.798 38.1962 34.3029 37.5881 34.654L26.0001 41.346C25.392 41.6971 24.7023 41.8819 24.0001 41.8819C23.298 41.8819 22.6082 41.6971 22.0001 41.346L10.4121 34.654C9.80405 34.3029 9.29911 33.798 8.94803 33.1899C8.59696 32.5819 8.41213 31.8921 8.41211 31.19V15.5L24.0001 6.5Z"
                            stroke="#FFBF00"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M24.0001 14.5V24.5M24.0001 24.5L15.3401 29.5M24.0001 24.5L32.6601 29.5"
                            stroke="#FFBF00"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </section>
                      <h3>3D Services</h3>
                      <p>
                        We provide product development services such as 3D
                        scanning play a very key role in the process of product
                        design, we do have inhouse 3D printer which help in
                        bringing our designs and products to reality to help us
                        check the functional and aesthetic requirements before
                        we move along the process of manufacturing .
                      </p>
                      <Link to="/3d-scanning" className="yellow-button">
                        <p>Explore</p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="7"
                          height="13"
                          viewBox="0 0 7 13"
                          fill="none"
                        >
                          <path
                            d="M2.00933 12.089L0.833496 10.9106L5.24099 6.49981L0.833496 2.08898L2.01266 0.910645L6.41682 5.32148C6.72927 5.63402 6.9048 6.05787 6.9048 6.49981C6.9048 6.94175 6.72927 7.3656 6.41682 7.67814L2.00933 12.089Z"
                            fill="#1A1A1A"
                          />
                        </svg>
                      </Link>
                    </div>
                    <div className="s-services-container-info-line"></div>
                    <div className="s-services-container-info-right">
                      <Link
                        to="/3d-printing"
                        className="s-services-container-info-set"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M17.571 18.5H20.4C20.5591 18.5 20.7117 18.4368 20.8243 18.3243C20.9368 18.2117 21 18.0591 21 17.9V11.5C21 10.4391 20.5786 9.42172 19.8284 8.67157C19.0783 7.92143 18.0609 7.5 17 7.5H7C5.93913 7.5 4.92172 7.92143 4.17157 8.67157C3.42143 9.42172 3 10.4391 3 11.5V17.9C3 18.0591 3.06321 18.2117 3.17574 18.3243C3.28826 18.4368 3.44087 18.5 3.6 18.5H6.429M8 7.5V4.1C8 3.94087 8.06321 3.78826 8.17574 3.67574C8.28826 3.56321 8.44087 3.5 8.6 3.5H15.4C15.5591 3.5 15.7117 3.56321 15.8243 3.67574C15.9368 3.78826 16 3.94087 16 4.1V7.5"
                            stroke="url(#paint0_linear_113_1724)"
                            strokeOpacity="0.8"
                          />
                          <path
                            d="M6.09809 20.815L6.42809 18.5L6.92609 15.015C6.94655 14.872 7.01788 14.7413 7.127 14.6467C7.23611 14.5521 7.37568 14.5 7.52009 14.5H16.4801C16.6245 14.5 16.7641 14.5521 16.8732 14.6467C16.9823 14.7413 17.0536 14.872 17.0741 15.015L17.5701 18.5L17.9011 20.815C17.9133 20.9001 17.907 20.9868 17.8828 21.0693C17.8585 21.1518 17.8168 21.2281 17.7604 21.2931C17.7041 21.358 17.6345 21.4101 17.5563 21.4458C17.478 21.4815 17.3931 21.5 17.3071 21.5H6.69209C6.60611 21.5 6.52113 21.4815 6.44292 21.4458C6.3647 21.4101 6.29507 21.358 6.23874 21.2931C6.18241 21.2281 6.1407 21.1518 6.11643 21.0693C6.09217 20.9868 6.08591 20.9001 6.09809 20.815Z"
                            stroke="url(#paint1_linear_113_1724)"
                            strokeOpacity="0.8"
                          />
                          <path
                            d="M17 10.51L17.01 10.499"
                            stroke="url(#paint2_linear_113_1724)"
                            strokeOpacity="0.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_113_1724"
                              x1="12"
                              y1="3.5"
                              x2="12"
                              y2="18.5"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_113_1724"
                              x1="11.9996"
                              y1="14.5"
                              x2="11.9996"
                              y2="21.5"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                            <linearGradient
                              id="paint2_linear_113_1724"
                              x1="17.005"
                              y1="10.499"
                              x2="17.005"
                              y2="10.51"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>3D Printing</h4>
                      </Link>
                      <Link
                        to="/3d-scanning"
                        className="s-services-container-info-set"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M8 3.5H4C3.73478 3.5 3.48043 3.60536 3.29289 3.79289C3.10536 3.98043 3 4.23478 3 4.5V8.5M8 21.5H4C3.73478 21.5 3.48043 21.3946 3.29289 21.2071C3.10536 21.0196 3 20.7652 3 20.5V16.5M16 21.5H20C20.2652 21.5 20.5196 21.3946 20.7071 21.2071C20.8946 21.0196 21 20.7652 21 20.5V16.5M16 3.5H20C20.2652 3.5 20.5196 3.60536 20.7071 3.79289C20.8946 3.98043 21 4.23478 21 4.5V8.5M17 12.5H7M13.5 8.5H10.5M13.5 16.5H10.5"
                            stroke="url(#paint0_linear_113_1719)"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_113_1719"
                              x1="12"
                              y1="3.5"
                              x2="12"
                              y2="21.5"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop offset="1" stopColor="#FFBF00" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <h4>3D Scanning</h4>
                      </Link>
                    </div>
                  </div>
                )}
            </div>
          ))}
        </div>
        {activeService === "General_Engineering" && (
          <div className="s-services-container-info general-engineering notMobile">
            <div className="s-services-container-info-left">
              <section>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="49"
                  viewBox="0 0 48 49"
                  fill="none"
                >
                  <mask id="path-1-inside-1_6459_8947" fill="white">
                    <path d="M38.8599 26.4601C38.9399 25.8201 38.9999 25.1801 38.9999 24.5001C38.9999 23.8201 38.9399 23.1801 38.8599 22.5401L43.0799 19.2401C43.4599 18.9401 43.5599 18.4001 43.3199 17.9601L39.3199 11.0401C39.202 10.8337 39.0145 10.6761 38.7909 10.5955C38.5674 10.5148 38.3224 10.5165 38.0999 10.6001L33.1199 12.6001C32.0799 11.8001 30.9599 11.1401 29.7399 10.6401L28.9799 5.34005C28.946 5.10509 28.828 4.89042 28.6477 4.73593C28.4675 4.58143 28.2373 4.49762 27.9999 4.50005H19.9999C19.4999 4.50005 19.0799 4.86005 19.0199 5.34005L18.2599 10.6401C17.0399 11.1401 15.9199 11.8201 14.8799 12.6001L9.89992 10.6001C9.78368 10.5618 9.66228 10.5416 9.53992 10.5401C9.19992 10.5401 8.85992 10.7201 8.67992 11.0401L4.67992 17.9601C4.41992 18.4001 4.53992 18.9401 4.91992 19.2401L9.13992 22.5401C9.05992 23.1801 8.99992 23.8401 8.99992 24.5001C8.99992 25.1601 9.05992 25.8201 9.13992 26.4601L4.91992 29.7601C4.53992 30.0601 4.43992 30.6001 4.67992 31.0401L8.67992 37.9601C8.79782 38.1664 8.98536 38.324 9.20892 38.4046C9.43248 38.4853 9.67745 38.4836 9.89992 38.4001L14.8799 36.4001C15.9199 37.2001 17.0399 37.8601 18.2599 38.3601L19.0199 43.6601C19.0799 44.1401 19.4999 44.5001 19.9999 44.5001H27.9999C28.4999 44.5001 28.9199 44.1401 28.9799 43.6601L29.7399 38.3601C30.9599 37.8601 32.0799 37.1801 33.1199 36.4001L38.0999 38.4001C38.2199 38.4401 38.3399 38.4601 38.4599 38.4601C38.7999 38.4601 39.1399 38.2801 39.3199 37.9601L43.3199 31.0401C43.5599 30.6001 43.4599 30.0601 43.0799 29.7601L38.8599 26.4601ZM34.8999 23.0401C34.9799 23.6601 34.9999 24.0801 34.9999 24.5001C34.9999 24.9201 34.9599 25.3601 34.8999 25.9601L34.6199 28.2201L36.3999 29.6201L38.5599 31.3001L37.1599 33.7201L34.6199 32.7001L32.5399 31.8601L30.7399 33.2201C29.8799 33.8601 29.0599 34.3401 28.2399 34.6801L26.1199 35.5401L25.7999 37.8001L25.3999 40.5001H22.5999L22.2199 37.8001L21.8999 35.5401L19.7799 34.6801C18.9199 34.3201 18.1199 33.8601 17.3199 33.26L15.4999 31.8601L13.3799 32.7201L10.8399 33.7401L9.43992 31.3201L11.5999 29.6401L13.3799 28.2401L13.0999 25.9801C13.0399 25.3601 12.9999 24.9001 12.9999 24.5001C12.9999 24.1001 13.0399 23.6401 13.0999 23.0401L13.3799 20.7801L11.5999 19.3801L9.43992 17.7001L10.8399 15.2801L13.3799 16.3001L15.4599 17.1401L17.2599 15.7801C18.1199 15.1401 18.9399 14.6601 19.7599 14.3201L21.8799 13.4601L22.1999 11.2001L22.5999 8.50005H25.3799L25.7599 11.2001L26.0799 13.4601L28.1999 14.3201C29.0599 14.6801 29.8599 15.1401 30.6599 15.7401L32.4799 17.1401L34.5999 16.2801L37.1399 15.2601L38.5399 17.6801L36.3999 19.3801L34.6199 20.7801L34.8999 23.0401ZM23.9999 16.5001C19.5799 16.5001 15.9999 20.0801 15.9999 24.5001C15.9999 28.9201 19.5799 32.5001 23.9999 32.5001C28.4199 32.5001 31.9999 28.9201 31.9999 24.5001C31.9999 20.0801 28.4199 16.5001 23.9999 16.5001ZM23.9999 28.5001C21.7999 28.5001 19.9999 26.7001 19.9999 24.5001C19.9999 22.3001 21.7999 20.5001 23.9999 20.5001C26.1999 20.5001 27.9999 22.3001 27.9999 24.5001C27.9999 26.7001 26.1999 28.5001 23.9999 28.5001Z" />
                  </mask>
                  <path
                    d="M38.8599 26.4601C38.9399 25.8201 38.9999 25.1801 38.9999 24.5001C38.9999 23.8201 38.9399 23.1801 38.8599 22.5401L43.0799 19.2401C43.4599 18.9401 43.5599 18.4001 43.3199 17.9601L39.3199 11.0401C39.202 10.8337 39.0145 10.6761 38.7909 10.5955C38.5674 10.5148 38.3224 10.5165 38.0999 10.6001L33.1199 12.6001C32.0799 11.8001 30.9599 11.1401 29.7399 10.6401L28.9799 5.34005C28.946 5.10509 28.828 4.89042 28.6477 4.73593C28.4675 4.58143 28.2373 4.49762 27.9999 4.50005H19.9999C19.4999 4.50005 19.0799 4.86005 19.0199 5.34005L18.2599 10.6401C17.0399 11.1401 15.9199 11.8201 14.8799 12.6001L9.89992 10.6001C9.78368 10.5618 9.66228 10.5416 9.53992 10.5401C9.19992 10.5401 8.85992 10.7201 8.67992 11.0401L4.67992 17.9601C4.41992 18.4001 4.53992 18.9401 4.91992 19.2401L9.13992 22.5401C9.05992 23.1801 8.99992 23.8401 8.99992 24.5001C8.99992 25.1601 9.05992 25.8201 9.13992 26.4601L4.91992 29.7601C4.53992 30.0601 4.43992 30.6001 4.67992 31.0401L8.67992 37.9601C8.79782 38.1664 8.98536 38.324 9.20892 38.4046C9.43248 38.4853 9.67745 38.4836 9.89992 38.4001L14.8799 36.4001C15.9199 37.2001 17.0399 37.8601 18.2599 38.3601L19.0199 43.6601C19.0799 44.1401 19.4999 44.5001 19.9999 44.5001H27.9999C28.4999 44.5001 28.9199 44.1401 28.9799 43.6601L29.7399 38.3601C30.9599 37.8601 32.0799 37.1801 33.1199 36.4001L38.0999 38.4001C38.2199 38.4401 38.3399 38.4601 38.4599 38.4601C38.7999 38.4601 39.1399 38.2801 39.3199 37.9601L43.3199 31.0401C43.5599 30.6001 43.4599 30.0601 43.0799 29.7601L38.8599 26.4601ZM34.8999 23.0401C34.9799 23.6601 34.9999 24.0801 34.9999 24.5001C34.9999 24.9201 34.9599 25.3601 34.8999 25.9601L34.6199 28.2201L36.3999 29.6201L38.5599 31.3001L37.1599 33.7201L34.6199 32.7001L32.5399 31.8601L30.7399 33.2201C29.8799 33.8601 29.0599 34.3401 28.2399 34.6801L26.1199 35.5401L25.7999 37.8001L25.3999 40.5001H22.5999L22.2199 37.8001L21.8999 35.5401L19.7799 34.6801C18.9199 34.3201 18.1199 33.8601 17.3199 33.26L15.4999 31.8601L13.3799 32.7201L10.8399 33.7401L9.43992 31.3201L11.5999 29.6401L13.3799 28.2401L13.0999 25.9801C13.0399 25.3601 12.9999 24.9001 12.9999 24.5001C12.9999 24.1001 13.0399 23.6401 13.0999 23.0401L13.3799 20.7801L11.5999 19.3801L9.43992 17.7001L10.8399 15.2801L13.3799 16.3001L15.4599 17.1401L17.2599 15.7801C18.1199 15.1401 18.9399 14.6601 19.7599 14.3201L21.8799 13.4601L22.1999 11.2001L22.5999 8.50005H25.3799L25.7599 11.2001L26.0799 13.4601L28.1999 14.3201C29.0599 14.6801 29.8599 15.1401 30.6599 15.7401L32.4799 17.1401L34.5999 16.2801L37.1399 15.2601L38.5399 17.6801L36.3999 19.3801L34.6199 20.7801L34.8999 23.0401ZM23.9999 16.5001C19.5799 16.5001 15.9999 20.0801 15.9999 24.5001C15.9999 28.9201 19.5799 32.5001 23.9999 32.5001C28.4199 32.5001 31.9999 28.9201 31.9999 24.5001C31.9999 20.0801 28.4199 16.5001 23.9999 16.5001ZM23.9999 28.5001C21.7999 28.5001 19.9999 26.7001 19.9999 24.5001C19.9999 22.3001 21.7999 20.5001 23.9999 20.5001C26.1999 20.5001 27.9999 22.3001 27.9999 24.5001C27.9999 26.7001 26.1999 28.5001 23.9999 28.5001Z"
                    fill="#FFBF00"
                    stroke="#2B2B2B"
                    strokeWidth="2.4"
                    mask="url(#path-1-inside-1_6459_8947)"
                  />
                </svg>
              </section>
              <h3>General Engineering</h3>
              <p>
                At Koios Engineering, our General Engineering services are built
                on precision, innovation, and performance. We bring together
                advanced mechanical design, detailed CAD modeling, and expert
                manufacturing to deliver engineering solutions that meet
                real-world demands. Whether it’s a single component or a complex
                system, we design and build with purpose.
              </p>
              <Link
                to="/general-engineering-services"
                className="yellow-button"
              >
                <p>Explore</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7"
                  height="13"
                  viewBox="0 0 7 13"
                  fill="none"
                >
                  <path
                    d="M2.00933 12.089L0.833496 10.9106L5.24099 6.49981L0.833496 2.08898L2.01266 0.910645L6.41682 5.32148C6.72927 5.63402 6.9048 6.05787 6.9048 6.49981C6.9048 6.94175 6.72927 7.3656 6.41682 7.67814L2.00933 12.089Z"
                    fill="#1A1A1A"
                  />
                </svg>
              </Link>
            </div>
            <div className="s-services-container-info-line"></div>
            <div className="s-services-container-info-right">
              <Link
                to="/mechanical_design"
                className="s-services-container-info-set"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M3.29594 21.1018L9.65994 14.7378M17.6739 11.9078L15.7689 17.6228C15.7385 17.7144 15.6865 17.7974 15.6172 17.8646C15.5479 17.9318 15.4634 17.9813 15.3709 18.0088L3.69294 21.4798C3.58773 21.5111 3.47597 21.5129 3.36981 21.485C3.26365 21.4572 3.16717 21.4007 3.09087 21.3218C3.01456 21.2429 2.96135 21.1446 2.93703 21.0376C2.91272 20.9306 2.91822 20.819 2.95294 20.7148L6.74494 9.34084C6.77212 9.25917 6.81655 9.18431 6.87521 9.12133C6.93388 9.05835 7.0054 9.00873 7.08494 8.97584L12.4719 6.75784C12.5815 6.71261 12.7019 6.70082 12.8181 6.72395C12.9343 6.74709 13.0411 6.80411 13.1249 6.88784L17.5289 11.2938C17.6077 11.3726 17.663 11.4718 17.6887 11.5802C17.7143 11.6887 17.7092 11.8021 17.6739 11.9078Z"
                    stroke="url(#paint0_linear_6466_8960)"
                    strokeOpacity="0.8"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.7918 11.556L20.6198 8.72699C20.9948 8.35194 21.2054 7.84332 21.2054 7.31299C21.2054 6.78266 20.9948 6.27405 20.6198 5.89899L18.4998 3.77699C18.3141 3.59119 18.0936 3.4438 17.8509 3.34324C17.6082 3.24268 17.3481 3.19092 17.0853 3.19092C16.8226 3.19092 16.5625 3.24268 16.3198 3.34324C16.0771 3.4438 15.8566 3.59119 15.6708 3.77699L12.8428 6.60599M11.7808 12.616C11.6415 12.4767 11.4761 12.3663 11.2941 12.2909C11.1121 12.2156 10.917 12.1768 10.72 12.1769C10.523 12.1769 10.3279 12.2158 10.1459 12.2912C9.96396 12.3666 9.79861 12.4772 9.65934 12.6165C9.52007 12.7558 9.40962 12.9212 9.33427 13.1032C9.25892 13.2853 9.22017 13.4803 9.22021 13.6773C9.22026 13.8743 9.25911 14.0694 9.33454 14.2514C9.40997 14.4334 9.52051 14.5987 9.65984 14.738C9.94124 15.0193 10.3228 15.1772 10.7207 15.1771C11.1186 15.177 11.5001 15.0189 11.7813 14.7375C12.0626 14.4561 12.2206 14.0745 12.2205 13.6766C12.2204 13.2788 12.0622 12.8973 11.7808 12.616Z"
                    stroke="url(#paint1_linear_6466_8960)"
                    strokeOpacity="0.8"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_6466_8960"
                      x1="10.3134"
                      y1="6.7124"
                      x2="10.3134"
                      y2="21.5047"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_6466_8960"
                      x1="15.2128"
                      y1="3.19092"
                      x2="15.2128"
                      y2="15.1771"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>Design</h4>
              </Link>
              <Link
                to="/mechanical_manufacturing"
                className="s-services-container-info-set"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M20.4692 6.33333L15 11.7375V6.33333H13.5615L8.33333 11.6361V3H2V23H22V6.33333H20.4692ZM20.6667 21.6667H3.33333V4.33333H7V13.3333H8.53242L13.6667 8.12575V13.3333H15.2818L20.6667 8.0125V21.6667Z"
                    fill="url(#paint0_linear_6473_9196)"
                    fillOpacity="0.8"
                  />
                  <path
                    d="M5 16.1635V16.5096H6.76471V15.125H5V16.1635ZM5 18.2404H6.76471V19.625H5V18.2404ZM9.41176 16.1635V16.5096H11.1765V15.125H9.41176V16.1635ZM9.41176 18.2404H11.1765V19.625H9.41176V18.2404ZM13.8235 16.1635V16.5096H15.5882V15.125H13.8235V16.1635ZM13.8235 18.2404H15.5882V19.625H13.8235V18.2404ZM18.2353 15.125H20V16.5096H18.2353V15.125ZM18.2353 18.2404H20V19.625H18.2353V18.2404Z"
                    fill="url(#paint1_linear_6473_9196)"
                    fillOpacity="0.8"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_6473_9196"
                      x1="12"
                      y1="3"
                      x2="12"
                      y2="23"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_6473_9196"
                      x1="12.5"
                      y1="15.125"
                      x2="12.5"
                      y2="19.625"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>Manufacturing</h4>
              </Link>
            </div>
          </div>
        )}

        {activeService === "Vehicle_Development" && (
          <div className="s-services-container-info vehicle-development notMobile">
            <div className="s-services-container-info-left">
              <section>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="49"
                  viewBox="0 0 48 49"
                  fill="none"
                >
                  <path
                    d="M7.5 24C7.5 22.9391 7.92143 21.9217 8.67157 21.1716C9.42172 20.4214 10.4391 20 11.5 20H36.5C37.5609 20 38.5783 20.4214 39.3284 21.1716C40.0786 21.9217 40.5 22.9391 40.5 24V36H7.5V24Z"
                    stroke="#FFBF00"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 28.5C15.1046 28.5 16 27.6046 16 26.5C16 25.3954 15.1046 24.5 14 24.5C12.8954 24.5 12 25.3954 12 26.5C12 27.6046 12.8954 28.5 14 28.5Z"
                    fill="#FFBF00"
                  />
                  <path
                    d="M34 28.5C35.1046 28.5 36 27.6046 36 26.5C36 25.3954 35.1046 24.5 34 24.5C32.8954 24.5 32 25.3954 32 26.5C32 27.6046 32.8954 28.5 34 28.5Z"
                    fill="#FFBF00"
                  />
                  <path
                    d="M20 30H28M12.542 11.634C12.8225 10.862 13.3338 10.1951 14.0065 9.72389C14.6792 9.25265 15.4807 8.9999 16.302 9H31.698C32.5193 8.9999 33.3208 9.25265 33.9935 9.72389C34.6662 10.1951 35.1775 10.862 35.458 11.634L38.5 20H9.5L12.542 11.634ZM7.5 36H14.376V39.4C14.376 40.0896 14.1021 40.7509 13.6145 41.2385C13.1269 41.7261 12.4656 42 11.776 42H10.1C9.41044 42 8.74912 41.7261 8.26152 41.2385C7.77393 40.7509 7.5 40.0896 7.5 39.4V36ZM33.626 36H40.5V39.4C40.5 40.0896 40.2261 40.7509 39.7385 41.2385C39.2509 41.7261 38.5896 42 37.9 42H36.226C35.5364 42 34.8751 41.7261 34.3875 41.2385C33.8999 40.7509 33.626 40.0896 33.626 39.4V36Z"
                    stroke="#FFBF00"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </section>
              <h3>Vehicle Development</h3>
              <p>
                We Build vehicles from the stage of design to manufacturing
                prototype which involves multiple activities which contribute to
                deliver a vehicle which is tested extensively to meet the
                technical requirement to ply on the roads safely .
              </p>
              <Link to="/vehicle-development" className="yellow-button">
                <p>Explore</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7"
                  height="13"
                  viewBox="0 0 7 13"
                  fill="none"
                >
                  <path
                    d="M2.00933 12.089L0.833496 10.9106L5.24099 6.49981L0.833496 2.08898L2.01266 0.910645L6.41682 5.32148C6.72927 5.63402 6.9048 6.05787 6.9048 6.49981C6.9048 6.94175 6.72927 7.3656 6.41682 7.67814L2.00933 12.089Z"
                    fill="#1A1A1A"
                  />
                </svg>
              </Link>
            </div>
            <div className="s-services-container-info-line"></div>
            <div className="s-services-container-info-right">
              {/* <a href="#" className="s-services-container-info-set">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M7.5 10.325H11.5V11.375H7.5V10.325ZM7.5 8.225H13.5V9.275H7.5V8.225ZM7.5 6.125H13.5V7.175H7.5V6.125Z"
                    fill="url(#paint0_linear_113_1694)"
                    fillOpacity="0.8"
                  />
                  <path
                    d="M3.93643 21.5714L7.95857 14.4314L13.2686 19.0671C13.4291 19.21 13.6198 19.3148 13.8264 19.3737C14.033 19.4326 14.2503 19.4442 14.462 19.4075C14.6737 19.3709 14.8744 19.2869 15.0492 19.162C15.2239 19.037 15.3683 18.8742 15.4714 18.6857L20.45 11.255L19.2636 10.4593L14.2636 17.9221L14.2136 17.9957L8.90286 13.36C8.74239 13.218 8.55208 13.1138 8.34596 13.0552C8.13985 12.9966 7.9232 12.985 7.71202 13.0214C7.50083 13.0577 7.30051 13.141 7.12584 13.2652C6.95118 13.3893 6.80662 13.5511 6.70286 13.7386L3.42857 19.5593V3H2V21.5714C2 21.9503 2.15051 22.3137 2.41842 22.5816C2.68633 22.8495 3.04969 23 3.42857 23H22V21.5714H3.93643Z"
                    fill="url(#paint1_linear_113_1694)"
                    fillOpacity="0.8"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_113_1694"
                      x1="10.5"
                      y1="6.125"
                      x2="10.5"
                      y2="11.375"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_113_1694"
                      x1="12"
                      y1="3"
                      x2="12"
                      y2="23"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>Fea</h4>
              </a>
              <a href="#" className="s-services-container-info-set">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M17.25 4C18.2446 4 19.1984 4.39509 19.9016 5.09835C20.6049 5.80161 21 6.75544 21 7.75V9.25C21 9.44891 20.921 9.63968 20.7803 9.78033C20.6397 9.92098 20.4489 10 20.25 10C20.0511 10 19.8603 9.92098 19.7197 9.78033C19.579 9.63968 19.5 9.44891 19.5 9.25V7.75C19.5 7.15326 19.2629 6.58097 18.841 6.15901C18.419 5.73705 17.8467 5.5 17.25 5.5H15.75C15.5511 5.5 15.3603 5.42098 15.2197 5.28033C15.079 5.13968 15 4.94891 15 4.75C15 4.55109 15.079 4.36032 15.2197 4.21967C15.3603 4.07902 15.5511 4 15.75 4H17.25ZM6.75 4C5.75544 4 4.80161 4.39509 4.09835 5.09835C3.39509 5.80161 3 6.75544 3 7.75V9.25C3 9.44891 3.07902 9.63968 3.21967 9.78033C3.36032 9.92098 3.55109 10 3.75 10C3.94891 10 4.13968 9.92098 4.28033 9.78033C4.42098 9.63968 4.5 9.44891 4.5 9.25V7.75C4.5 7.15326 4.73705 6.58097 5.15901 6.15901C5.58097 5.73705 6.15326 5.5 6.75 5.5H8.25C8.44891 5.5 8.63968 5.42098 8.78033 5.28033C8.92098 5.13968 9 4.94891 9 4.75C9 4.55109 8.92098 4.36032 8.78033 4.21967C8.63968 4.07902 8.44891 4 8.25 4H6.75ZM17.25 22C18.2446 22 19.1984 21.6049 19.9016 20.9016C20.6049 20.1984 21 19.2446 21 18.25V16.75C21 16.5511 20.921 16.3603 20.7803 16.2197C20.6397 16.079 20.4489 16 20.25 16C20.0511 16 19.8603 16.079 19.7197 16.2197C19.579 16.3603 19.5 16.5511 19.5 16.75V18.25C19.5 18.8467 19.2629 19.419 18.841 19.841C18.419 20.2629 17.8467 20.5 17.25 20.5H15.75C15.5511 20.5 15.3603 20.579 15.2197 20.7197C15.079 20.8603 15 21.0511 15 21.25C15 21.4489 15.079 21.6397 15.2197 21.7803C15.3603 21.921 15.5511 22 15.75 22H17.25ZM3 18.25C3 19.2446 3.39509 20.1984 4.09835 20.9016C4.80161 21.6049 5.75544 22 6.75 22H8.25C8.44891 22 8.63968 21.921 8.78033 21.7803C8.92098 21.6397 9 21.4489 9 21.25C9 21.0511 8.92098 20.8603 8.78033 20.7197C8.63968 20.579 8.44891 20.5 8.25 20.5H6.75C6.15326 20.5 5.58097 20.2629 5.15901 19.841C4.73705 19.419 4.5 18.8467 4.5 18.25V16.75C4.5 16.5511 4.42098 16.3603 4.28033 16.2197C4.13968 16.079 3.94891 16 3.75 16C3.55109 16 3.36032 16.079 3.21967 16.2197C3.07902 16.3603 3 16.5511 3 16.75V18.25ZM12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13C15 12.2044 14.6839 11.4413 14.1213 10.8787C13.5587 10.3161 12.7956 10 12 10C11.2044 10 10.4413 10.3161 9.87868 10.8787C9.31607 11.4413 9 12.2044 9 13C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16ZM12 14.5C11.6022 14.5 11.2206 14.342 10.9393 14.0607C10.658 13.7794 10.5 13.3978 10.5 13C10.5 12.6022 10.658 12.2206 10.9393 11.9393C11.2206 11.658 11.6022 11.5 12 11.5C12.3978 11.5 12.7794 11.658 13.0607 11.9393C13.342 12.2206 13.5 12.6022 13.5 13C13.5 13.3978 13.342 13.7794 13.0607 14.0607C12.7794 14.342 12.3978 14.5 12 14.5ZM7.5 9.625C7.79837 9.625 8.08452 9.50647 8.2955 9.2955C8.50647 9.08452 8.625 8.79837 8.625 8.5C8.625 8.20163 8.50647 7.91548 8.2955 7.7045C8.08452 7.49353 7.79837 7.375 7.5 7.375C7.20163 7.375 6.91548 7.49353 6.7045 7.7045C6.49353 7.91548 6.375 8.20163 6.375 8.5C6.375 8.79837 6.49353 9.08452 6.7045 9.2955C6.91548 9.50647 7.20163 9.625 7.5 9.625Z"
                    fill="url(#paint0_linear_113_1699)"
                    fillOpacity="0.8"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_113_1699"
                      x1="12"
                      y1="4"
                      x2="12"
                      y2="22"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>Styling</h4>
              </a> */}
              <Link
                to="/automotive-manufacturing-solutions"
                className="s-services-container-info-set"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.2661 5.81061L18.1585 5H15.6436L15.5358 5.81009L15.4686 6.31198L15.3366 6.38834L15.2183 6.46634L14.7734 6.27702L14.0565 5.97209L13.6695 6.67873L13.1883 7.55722L12.8006 8.26508L13.41 8.76945L13.7865 9.08094L13.7853 9.09552C13.7831 9.14206 13.782 9.18865 13.782 9.23525L13.7853 9.37386L13.7874 9.39341L13.4101 9.70602L12.8003 10.2103L13.1881 10.9184L13.6696 11.7973L14.0565 12.5039L14.7734 12.1991L15.2174 12.0099L15.3408 12.0914L15.4686 12.1642L15.5346 12.66L15.6421 13.4705H18.1569L18.2648 12.6605L18.3312 12.1576L18.464 12.0822L18.5815 12.0033L19.0271 12.1935L19.744 12.4984L20.1311 11.7918L20.6122 10.9133L21 10.2055L20.3906 9.70109L20.0142 9.38961L20.0152 9.37503C20.0174 9.32784 20.0186 9.28125 20.0185 9.23525L20.0153 9.09669L20.0133 9.07527L20.3907 8.76402L21 8.25964L20.6122 7.55183L20.131 6.67316L19.7439 5.96666L19.0272 6.27144L18.5824 6.45973L18.4598 6.37906L18.3312 6.30537L18.2661 5.81061ZM16.9877 11.1176C17.9719 11.1176 18.7696 10.2748 18.7696 9.23525C18.7696 8.19566 17.9719 7.35294 16.9877 7.35294C16.0036 7.35294 15.2059 8.19566 15.2059 9.23525C15.2059 10.2748 16.0036 11.1176 16.9877 11.1176ZM8.46567 13.34L8.35819 12.5294H5.84325L5.73539 13.3394L5.66822 13.8414L5.53622 13.9177L5.41786 13.9957L4.97306 13.8065L4.2562 13.5015L3.86916 14.2082L3.38794 15.0867L3.00019 15.7945L3.60956 16.2989L3.98611 16.6103L3.98503 16.6249C3.98279 16.6715 3.98165 16.7181 3.98161 16.7647L3.98494 16.9032L3.98705 16.9228L3.6097 17.2355L3 17.7397L3.3878 18.4478L3.8692 19.3267L4.2562 20.0333L4.97302 19.7285L5.41697 19.5393L5.54044 19.6209L5.66822 19.6936L5.73431 20.1894L5.84184 21H8.35659L8.46445 20.1899L8.53083 19.687L8.66363 19.6116L8.78119 19.5327L9.22678 19.7229L9.94364 20.0278L10.3307 19.3212L10.8119 18.4427L11.1997 17.7349L10.5902 17.2305L10.2138 16.919L10.2148 16.9045C10.2171 16.8572 10.2182 16.8106 10.2182 16.7647L10.2149 16.6261L10.2129 16.6047L10.5903 16.2935L11.1997 15.7891L10.8119 15.0813L10.3306 14.2026L9.94364 13.496L9.22683 13.8008L8.78208 13.9892L8.65941 13.9085L8.53083 13.8348L8.46567 13.34ZM7.18739 18.647C8.17148 18.647 8.96925 17.8043 8.96925 16.7647C8.96925 15.725 8.17148 14.8823 7.18739 14.8823C6.20325 14.8823 5.40548 15.725 5.40548 16.7647C5.40548 17.8043 6.20325 18.647 7.18739 18.647ZM21 19H12V21H21V19ZM3 5H12V6.99997H3V5ZM12 11H9.99998V13H12V11Z"
                    fill="url(#paint0_linear_113_1704)"
                    fillOpacity="0.8"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_113_1704"
                      x1="12"
                      y1="5"
                      x2="12"
                      y2="21"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>Automotive Manufacturing</h4>
              </Link>
              <Link
                to="/automotive-design-services"
                className="s-services-container-info-set"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M23 10H21.5C20.9473 10 20.4688 10.3038 20.2085 10.75H5.051L7.01975 5.5H12.5V4H7.01975C6.71467 4.00096 6.41706 4.09445 6.16625 4.26813C5.91543 4.44182 5.72322 4.68751 5.615 4.97275L3.7295 10H2V11.5H3.5V18.25C3.5 19.0765 4.17275 19.75 5 19.75V22H6.5V19.75H18.5V22H20V19.75C20.8265 19.75 21.5 19.0765 21.5 18.25V11.5H23V10ZM5 18.25V16H7.25V14.5H5V12.25H20V14.5H17.75V16H20V18.25H5Z"
                    fill="url(#paint0_linear_113_1709)"
                    fillOpacity="0.8"
                  />
                  <path
                    d="M8.98413 15.4558H14.9841V16.9558H8.98413V15.4558ZM22.1526 2.39453L17.2101 7.33703L15.2676 5.39453L14.2101 6.45203L17.2101 9.45203L23.2101 3.45203L22.1526 2.39453Z"
                    fill="url(#paint1_linear_113_1709)"
                    fillOpacity="0.8"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_113_1709"
                      x1="12.5"
                      y1="4"
                      x2="12.5"
                      y2="22"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_113_1709"
                      x1="16.0971"
                      y1="2.39453"
                      x2="16.0971"
                      y2="16.9558"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>Automotive Design</h4>
              </Link>
              <Link
                to="/electric-vehicle-development-services"
                className="s-services-container-info-set"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M10 13.154V21M13.333 6.385V3M6.667 6.385V3M15 8.385V11.154C15 11.6844 14.7893 12.1931 14.4142 12.5682C14.0391 12.9433 13.5304 13.154 13 13.154H7C6.46957 13.154 5.96086 12.9433 5.58579 12.5682C5.21071 12.1931 5 11.6844 5 11.154L5 8.384C5 7.85357 5.21071 7.34486 5.58579 6.96979C5.96086 6.59471 6.46957 6.384 7 6.384H13C13.5304 6.384 14.0391 6.59471 14.4142 6.96979C14.7893 7.34486 15 7.85357 15 8.384V8.385Z"
                    stroke="url(#paint0_linear_113_1689)"
                    strokeOpacity="0.8"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M16.667 16L15 19H19L17.333 22"
                    stroke="url(#paint1_linear_113_1689)"
                    strokeOpacity="0.8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_113_1689"
                      x1="10"
                      y1="3"
                      x2="10"
                      y2="21"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_113_1689"
                      x1="17"
                      y1="16"
                      x2="17"
                      y2="22"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>Electric Vehicle</h4>
              </Link>
            </div>
          </div>
        )}

        {activeService == "3D_Services" && (
          <div className="s-services-container-info threeD-services notMobile">
            <div className="s-services-container-info-left">
              <section>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="49"
                  viewBox="0 0 48 49"
                  fill="none"
                >
                  <path
                    d="M24.0001 6.5L39.5881 15.5V31.19C39.5881 31.8921 39.4033 32.5819 39.0522 33.1899C38.7011 33.798 38.1962 34.3029 37.5881 34.654L26.0001 41.346C25.392 41.6971 24.7023 41.8819 24.0001 41.8819C23.298 41.8819 22.6082 41.6971 22.0001 41.346L10.4121 34.654C9.80405 34.3029 9.29911 33.798 8.94803 33.1899C8.59696 32.5819 8.41213 31.8921 8.41211 31.19V15.5L24.0001 6.5Z"
                    stroke="#FFBF00"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M24.0001 14.5V24.5M24.0001 24.5L15.3401 29.5M24.0001 24.5L32.6601 29.5"
                    stroke="#FFBF00"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </section>
              <h3>3D Services</h3>
              <p>
                We provide product development services such as 3D scanning play
                a very key role in the process of product design, we do have
                inhouse 3D printer which help in bringing our designs and
                products to reality to help us check the functional and
                aesthetic requirements before we move along the process of
                manufacturing .
              </p>
              <Link to="/3d-scanning" className="yellow-button">
                <p>Explore</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7"
                  height="13"
                  viewBox="0 0 7 13"
                  fill="none"
                >
                  <path
                    d="M2.00933 12.089L0.833496 10.9106L5.24099 6.49981L0.833496 2.08898L2.01266 0.910645L6.41682 5.32148C6.72927 5.63402 6.9048 6.05787 6.9048 6.49981C6.9048 6.94175 6.72927 7.3656 6.41682 7.67814L2.00933 12.089Z"
                    fill="#1A1A1A"
                  />
                </svg>
              </Link>
            </div>
            <div className="s-services-container-info-line"></div>
            <div className="s-services-container-info-right">
              <Link to="/3d-printing" className="s-services-container-info-set">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M17.571 18.5H20.4C20.5591 18.5 20.7117 18.4368 20.8243 18.3243C20.9368 18.2117 21 18.0591 21 17.9V11.5C21 10.4391 20.5786 9.42172 19.8284 8.67157C19.0783 7.92143 18.0609 7.5 17 7.5H7C5.93913 7.5 4.92172 7.92143 4.17157 8.67157C3.42143 9.42172 3 10.4391 3 11.5V17.9C3 18.0591 3.06321 18.2117 3.17574 18.3243C3.28826 18.4368 3.44087 18.5 3.6 18.5H6.429M8 7.5V4.1C8 3.94087 8.06321 3.78826 8.17574 3.67574C8.28826 3.56321 8.44087 3.5 8.6 3.5H15.4C15.5591 3.5 15.7117 3.56321 15.8243 3.67574C15.9368 3.78826 16 3.94087 16 4.1V7.5"
                    stroke="url(#paint0_linear_113_1724)"
                    strokeOpacity="0.8"
                  />
                  <path
                    d="M6.09809 20.815L6.42809 18.5L6.92609 15.015C6.94655 14.872 7.01788 14.7413 7.127 14.6467C7.23611 14.5521 7.37568 14.5 7.52009 14.5H16.4801C16.6245 14.5 16.7641 14.5521 16.8732 14.6467C16.9823 14.7413 17.0536 14.872 17.0741 15.015L17.5701 18.5L17.9011 20.815C17.9133 20.9001 17.907 20.9868 17.8828 21.0693C17.8585 21.1518 17.8168 21.2281 17.7604 21.2931C17.7041 21.358 17.6345 21.4101 17.5563 21.4458C17.478 21.4815 17.3931 21.5 17.3071 21.5H6.69209C6.60611 21.5 6.52113 21.4815 6.44292 21.4458C6.3647 21.4101 6.29507 21.358 6.23874 21.2931C6.18241 21.2281 6.1407 21.1518 6.11643 21.0693C6.09217 20.9868 6.08591 20.9001 6.09809 20.815Z"
                    stroke="url(#paint1_linear_113_1724)"
                    strokeOpacity="0.8"
                  />
                  <path
                    d="M17 10.51L17.01 10.499"
                    stroke="url(#paint2_linear_113_1724)"
                    strokeOpacity="0.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_113_1724"
                      x1="12"
                      y1="3.5"
                      x2="12"
                      y2="18.5"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_113_1724"
                      x1="11.9996"
                      y1="14.5"
                      x2="11.9996"
                      y2="21.5"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_113_1724"
                      x1="17.005"
                      y1="10.499"
                      x2="17.005"
                      y2="10.51"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>3D Printing</h4>
              </Link>
              <Link to="/3d-scanning" className="s-services-container-info-set">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M8 3.5H4C3.73478 3.5 3.48043 3.60536 3.29289 3.79289C3.10536 3.98043 3 4.23478 3 4.5V8.5M8 21.5H4C3.73478 21.5 3.48043 21.3946 3.29289 21.2071C3.10536 21.0196 3 20.7652 3 20.5V16.5M16 21.5H20C20.2652 21.5 20.5196 21.3946 20.7071 21.2071C20.8946 21.0196 21 20.7652 21 20.5V16.5M16 3.5H20C20.2652 3.5 20.5196 3.60536 20.7071 3.79289C20.8946 3.98043 21 4.23478 21 4.5V8.5M17 12.5H7M13.5 8.5H10.5M13.5 16.5H10.5"
                    stroke="url(#paint0_linear_113_1719)"
                    strokeOpacity="0.8"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_113_1719"
                      x1="12"
                      y1="3.5"
                      x2="12"
                      y2="21.5"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset="1" stopColor="#FFBF00" />
                    </linearGradient>
                  </defs>
                </svg>
                <h4>3D Scanning</h4>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Services;
